<div
  *ngIf="details"
  class="preview-header-container flex-row"
  [ngClass]="{
    'people-preview-large': !smallWidthPreview && size !== 'popup',
    'people-preview-small': extraSmallWidthPreview,
  }"
>
  <div class="flex-column">
    <div class="flex-row preview-header-main" [ngClass]="{ focused: 'title' === methodsList[markedIndex]?.id }">
      <avatar
        data-cy="people-preview-avatar"
        class="preview-header-avatar"
        [ngClass]="{ 'avatar-launcher': isLauncher }"
        [url]="details?.avatar || details?.source?.view?.icon"
        [size]="'none'"
      ></avatar>
      <div class="flex-column preview-header-wrapper-titles">
        <span #title data-cy="people-preview-header" class="preview-header-name" (click)="onHeaderClick()">{{ details?.displayName }}</span>
        <span
          (mousedown)="copyValue($event, details?.jobTitle)"
          [pTooltip]="details.jobTitle"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          #subtitle
          data-cy="people-preview-jobtitle"
          class="preview-header-job-title"
          >{{ details?.jobTitle }}</span
        >
      </div>
    </div>
    <div class="flex-row" *ngIf="extraSmallWidthPreview">
      <ng-container *ngTemplateOutlet="contactLinksTemplate"></ng-container>
    </div>
  </div>
  <div class="flex-row preview-header-wrapper-btns">
    <div class="flex-row" *ngIf="!extraSmallWidthPreview">
      <ng-container *ngTemplateOutlet="contactLinksTemplate"></ng-container>
    </div>
    <div class="flex-row">
      <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
        <u-icon
          *ngIf="model?.isFavorite"
          class="preview-header-favorite"
          [model]="{ type: 'font', value: 'icon-star-solid' }"
          [styles]="{ width: '12px', height: '11.71px', color: 'var(--color-text-tertiary)' }"
        ></u-icon>
      </ng-container>
      <u-buttons
        *ngIf="!disableOpen"
        #openIcon
        pTooltip="Open"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
        (onClick)="openUrl()"
        type="secondary"
        class="open-icon"
        [ngClass]="{ focused: methodsList[markedIndex]?.id === 'open' }"
      >
        <u-icon [model]="{ type: 'font', value: 'icon-launch' }"></u-icon>
      </u-buttons>
      <square-button
        #actions
        [ngClass]="{ focused: 'actions' === methodsList[markedIndex]?.id }"
        data-cy="people-context-box-preview-btn"
        [active]="contextMenuHelper?.source === 'actions'"
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        >•••</square-button
      >
    </div>
  </div>
</div>

<ng-template #contactLinksTemplate>
  <div class="flex-row preview-header-wrapper-links-btn">
    <div *ngFor="let link of contactLinks | keyvalue; index as i">
      <u-button
        #linkElement
        pTooltip="Direct {{ link.key }} message"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
        (onClick)="peopleService.directMessage(link.value)"
        type="secondary"
        class="preview-header-link-btn icon-button"
        [onlyIcon]="true"
        [ngClass]="{ focused: link?.key === methodsList[markedIndex]?.id }"
      >
        <u-icon [model]="link.value.icon" [styles]="{ width: '14px', height: '14px' }"></u-icon>
      </u-button>
    </div>
    <u-button
      data-cy="people-preview-compose-email-btn"
      #emailElement
      pTooltip="Compose an email"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      (onClick)="peopleService.sendEmail(details)"
      type="secondary"
      class="icon-button"
      [onlyIcon]="true"
      [tabindex]="'-1'"
      [ngClass]="{ focused: 'email' === methodsList[markedIndex]?.id }"
    >
      <u-icon [model]="{ type: 'font', value: 'icon-envelope' }" [styles]="{ fontSize: '14px' }"></u-icon>
    </u-button>
  </div>
</ng-template>
